import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { noop, size } from 'lodash';

// local dependencies
import { calendar as Calendar } from 'modules/calendar';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { calendarRange as CalendarRange } from 'modules/calendarRange';
 *
 * // render
 * <CalendarRange propName='propValue'/>
 */
export const calendarRange = ( props ) => {

    // dynamic widget class name
    const widgetClassName = classnames( 'ui-calendar-range', props.className );

    return (
        <div className={ widgetClassName }>
            {/* head view */}
            

            {/* calendar view */}
            <Calendar
                className='ui-calendar-range__calendar'
                value={ props.value }
                selectRange={ true }
                allowPartialRange={ true }
                maxDate= { ! props.disableMaxDate ? moment( new Date() ).format( 'MM-DD-YYYY' ) : null }
                onChange={ ( selection ) => {
                    if( 2 === size( selection ) ) {
                        props.onChange( selection );

                        // setPartialSelected( false );
                    } else {

                        // setPartialSelected( true );
                    }
                } }
            />
        </div>
    );
};

// set display name
calendarRange.displayName = 'calendarRange';

// set default props
calendarRange.defaultProps = {
    value: [ moment( new Date() ).format( 'MM-DD-YYYY' ), moment( new Date() ).format( 'MM-DD-YYYY' ) ], // array of strings in `MM-DD-YY` format
    onChange: noop, // returns array of strings in `MM-DD-YY` format
    disableMaxDate: false
};

// prop types
calendarRange.propTypes = {};
